<template>
  <div class="select-first-town">
    <p class="popup-header">选择主城镇</p>

    <div class="faction-list h-outer-border around-4 bz0 h-bg brown-2">
      <div class="faction-item h-outer-border around-4 bw2 bz0 h-title nowrap"
           :class="{selected: selectedFaction === factionName }"
           :data-title="FACTION_CONF.FACTION_ENG_CH[factionName]"
           v-for="factionName in FACTION_CONF.INITIAL_FACTIONS"
           v-click-sound-button
           @click="handleSelectFaction(factionName)">
        <img :src="`${$rHost}/img/common/race/${factionName}.jpg`" alt="">
      </div>
    </div>
    <p class="faction-intro">{{ factionIntro[selectedFaction] }}</p>

    <div class="h-line separator"></div>

    <div class="footer">
      <button v-click-sound-button
              type="button"
              :disabled="submitLoading"
              class="h-btn primary"
              @click="submit">
        确认选择
      </button>
      <button v-click-sound-button
              type="button"
              class="h-btn primary"
              @click="closePopup">
        取消
      </button>
    </div>
  </div>
</template>

<script>
  import FACTION_CONF from '@js/config/faction'
  import factionIntro from './faction-intro'
  import API from '@js/api'

  export default {
    name: 'initial-town',

    data () {
      return {
        FACTION_CONF,
        factionIntro,
        selectedFaction: FACTION_CONF.INITIAL_FACTIONS[0],
        submitLoading: false,
      }
    },

    methods: {
      handleSelectFaction (faction) {
        this.selectedFaction = faction
      },

      async submit () {
        try {
          this.submitLoading = true
          await API.town.setInitialTown({
            town: FACTION_CONF.FACTIONS_VALUE[this.selectedFaction]
          })
          this.$emit('inited')
        } catch (err) {
          console.error(err)
        } finally {
          this.submitLoading = false
        }
      },

      closePopup () {
        this.$emit('close')
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .select-first-town
    width 400px

  .faction-list
    display flex
    flex-wrap wrap
    justify-content space-between
    padding 8px 8px 3px
    .faction-item
      margin-bottom 5px
      display flex
      justify-content center
      align-items center
      padding 2px
      width 90px
      height 60px
      > img
        height 100%
        filter grayscale(75%)
      &:hover
        > img
          filter grayscale(35%)
      &.selected
        outline 2px solid $colorLightBlue
        > img
          filter grayscale(0)

  .faction-intro
    margin-top 5px
    goldText1()
    height 48px
    line-height 16px
    font-size 12px
    letter-spacing 1px

  .h-line
    margin-top 5px

  .footer
    padding-bottom 5px
    text-align center
    display flex
    justify-content space-between
    .h-btn
      width 150px
      height 36px
      line-height 36px
      font-size 18px
      text-shadow 1px 1px 0 #fff

</style>
